module.exports = __webpack_public_path__ + "static/img/renmingwenxue.0dc5680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/renmingwenxue.png
// module id = gfHp
// module chunks = 36